import { defineMessages } from '../define';

export default defineMessages({
  'progress.notFound': { ru: 'Проект не найден.', en: 'Project not found.' },
  'progress.toProjects': { ru: 'К проектам', en: 'To projects' },
  'progress.failed': { ru: 'Не получилось', en: 'Something went wrong' },
  'progress.title.lead': { ru: 'Монтируем ', en: 'Building your ' },
  'progress.title.accent': { ru: 'ролик', en: 'reel' },
  'progress.failedDefault': {
    ru: 'Генерация прервалась. Попробуйте запустить ещё раз.',
    en: 'Generation was interrupted. Please try again.',
  },
  'progress.restart': { ru: 'Запустить заново', en: 'Start over' },
  'progress.fact.stage': { ru: 'Этап', en: 'Step' },
  'progress.fact.of': { ru: 'из {total}', en: 'of {total}' },
  'progress.fact.done': { ru: 'Готово', en: 'Done' },
  'progress.stage.uploading': { ru: 'Загрузка исходников', en: 'Uploading footage' },
  'progress.stage.transcribing': { ru: 'Расшифровка речи', en: 'Transcribing speech' },
  'progress.stage.analyzing': { ru: 'Анализ материалов', en: 'Analyzing footage' },
  'progress.stage.planning': { ru: 'Сценарий монтажа', en: 'Planning the edit' },
  'progress.stage.rendering': { ru: 'Рендер ролика', en: 'Rendering the reel' },
  'progress.stage.delivering': { ru: 'Отправка результата', en: 'Sending the result' },
  'progress.files': { ru: '{done} из {total} записей', en: '{done} of {total} clips' },
  'progress.working': { ru: 'в работе', en: 'in progress' },
  'progress.closeHint': {
    ru: 'Приложение можно закрыть — бот пришлёт готовый ролик в чат и кнопку «Открыть проект».',
    en: 'You can close the app. The bot will send the finished reel to the chat with an "Open project" button.',
  },
  'progress.stream.poll': {
    ru: 'Поток событий недоступен, статус обновляется опросом каждые 2 секунды.',
    en: 'Live updates are unavailable, so the status is refreshed every 2 seconds.',
  },
  'progress.stream.live': {
    ru: 'Статус приходит по прямому потоку событий.',
    en: 'The status updates live.',
  },
  'progress.allProjects': { ru: 'Ко всем проектам', en: 'All projects' },
  'progress.minimize': { ru: 'Свернуть приложение', en: 'Minimize app' },
});
